export default "__VITE_ASSET__3a2dd82d__"